import { createSelector } from 'reselect';
export const getUpdatePasswordError = state => state.errors.get('updatePassword');
export const getUpdatePasswordErrorMessage = createSelector([getUpdatePasswordError], updatePasswordError => {
  return updatePasswordError ? updatePasswordError.get('message') : undefined;
});
export const getUnrecoverableErrors = state => state.errors.get('unrecoverableErrors');